import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_EVALUATION_TYPES, 
    ADD_NEW_EVALUATION_TYPE, 
    UPDATE_EVALUATION_TYPE, 
    DELETE_EVALUATION_TYPE,
} from "./actionTypes";
import {
    getEvaluationTypesSuccess,
    getEvaluationTypesFail,
    addEvaluationTypeSuccess,
    addEvaluationTypeFail,
    updateEvaluationTypeSuccess,
    updateEvaluationTypeFail,
    deleteEvaluationTypeSuccess,
    deleteEvaluationTypeFail,

   

   
} from "./actions"

import {
    getEvaluationTypes,
    addNewEvaluationType,
    updateEvaluationType,
    deleteEvaluationType,

   
} from "helpers/evaluation-types/evaluation_types_backend_helper";
import { toast } from "react-toastify";

function* fetchEvaluationTypes() {
    try {

       
        const response = yield call(getEvaluationTypes)

         console.log("EVALUATION TYPES: ", response);
         
        yield put(getEvaluationTypesSuccess(response))
    } catch (error) {
        yield put(getEvaluationTypesFail(error))
    }
}

function* onAddNewEvaluationType({ payload }) {
    try {

        
        const response = yield call(addNewEvaluationType, payload)

        console.log("RESPONSE:", response);
        yield put(addEvaluationTypeSuccess(response.evaluation))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addEvaluationTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateEvaluationType({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateEvaluationType, payload)
        yield put(updateEvaluationTypeSuccess(response.evaluation))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateEvaluationTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteEvaluationType({ payload: data }) {

    try {
        const response = yield call(deleteEvaluationType, data)
        yield put(deleteEvaluationTypeSuccess(response.evaluationId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteEvaluationTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}




function* evaluationTypeSaga() {
    yield takeEvery(GET_EVALUATION_TYPES, fetchEvaluationTypes)
    yield takeEvery(ADD_NEW_EVALUATION_TYPE, onAddNewEvaluationType)
    yield takeEvery(UPDATE_EVALUATION_TYPE, onUpdateEvaluationType)
    yield takeEvery(DELETE_EVALUATION_TYPE, onDeleteEvaluationType)
    // Moyennes
}

export default evaluationTypeSaga;